module.exports = __webpack_public_path__ + "static/media/logotipo-principal.ae1d19ef.svg";